/*
 * Application Insights JavaScript SDK - Common, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { __extendsFn } from "@microsoft/applicationinsights-shims";
// THIS FILE WAS AUTOGENERATED
import { PageViewData } from './PageViewData';
/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    __extendsFn(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(PageViewData));
export { PageViewPerfData };
//# sourceMappingURL=PageViewPerfData.js.map